import React from 'react'
import Topheader from '../Home/topHeader/Topheader'
import Middlebar from '../Home/middleBar/Middlebar'
import NavMenu from '../Home/navigationBar/NavMenu'
import Footer from '../Home/footer/Footer'
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry"

const images = [
  "Q12.jpg",
  "Q3.jpg",
  "Q10.jpg",
  "Q11.jpg",
  "Q1.jpg",
  "Q2.jpg",
  "Q4.jpg",
  "Q5.jpg",
  "Q6.jpg",
  "Q7.jpg",
  "Q8.jpg",
  "Q9.jpg",
  // "Q13.jpg",
]

const Qawali = () => {
  return (
    <>
    <Topheader/>
    <Middlebar/>
    <NavMenu/>
      <div className="p-5 mb-5">
        <div className="head my-3 mt-6">
          <h1 className="text-6xl flex justify-center font-monserrat text-maroon">QAWAALI NIGHT</h1>
        </div>
        <div className="p-20 -mt-16">

        <ResponsiveMasonry
                columnsCountBreakPoints={{350: 1, 750: 2, 1000: 3}}
                >
                <Masonry gutter='15px'>
                    {images.map((image, i) => (
                      <img
                      key={i}
                      src={image}
                      // style={{width: "100%", display: "block"}}
                      className="w-1000 block rounded-lg"
                      alt=""
                      />
                      ))}
                </Masonry>
            </ResponsiveMasonry>
                      </div>
                </div> 
            <Footer/> 
    </>
  )
}

export default Qawali
